import React from "react";

import { useFormContext } from "react-hook-form/dist/react-hook-form.ie11";

import { DAYS, DEFAULT_HOURS } from "./constants";
import { MyWorkingHoursStateProviderProps } from "./types";
import { capitalize } from "lodash";
import { useTealium } from "@hubcapp/context";
import MyWorkingHours from "./MyWorkingHours";

const MyWorkingHoursStateProvider: React.FC<MyWorkingHoursStateProviderProps> = ({
  loading = false,
  disabled = false,
}) => {
  const { watch, setValue } = useFormContext();
  const workingHours = watch("workingHours");
  const { trackEvent } = useTealium();

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    trackEvent({
      eventCategory: "Preferences",
      eventAction: "Interaction",
      eventLabel: `Select All - ${event.target.checked == true ? "Yes" : "No"}`,
    });
    const newWorkingHours = {
      ...DAYS.reduce(
        (acc, day) => ({
          ...acc,
          [day]: event.target.checked
            ? workingHours[day] || DEFAULT_HOURS
            : null,
        }),
        {},
      ),
    };
    setValue("workingHours", newWorkingHours);
  };

  const handleSelectClick = (day: string) => {
    const newWorkingHours = {
      ...workingHours,
      [day]: workingHours[day] ? null : DEFAULT_HOURS,
    };
    setValue("workingHours", newWorkingHours);
    trackEvent({
      eventCategory: "Preferences",
      eventAction: "Interaction",
      eventLabel: `${capitalize(day)} - ${
        Boolean(workingHours[day]) ? "No" : "Yes"
      }`,
    });
  };

  const handleSliderChange = (day: string, newSliderValue: number[]) => {
    const newWorkingHours = {
      ...workingHours,
      [day]: {
        from: newSliderValue[0],
        to: newSliderValue[1],
      },
    };
    setValue("workingHours", newWorkingHours);
  };

  return (
    <MyWorkingHours
      workingHours={workingHours}
      handleSelectClick={handleSelectClick}
      handleSelectAllClick={handleSelectAllClick}
      handleSliderChange={handleSliderChange}
      loading={loading}
      disabled={disabled}
    />
  );
};

export default MyWorkingHoursStateProvider;
